import store from '../../../core/store';

export const listFolders = (stage_id) => {
  return store.dispatch({
    action: 'table.folders/LIST_FOLDERS',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/folders',
  });
};

export const createFolder = (stage_id, formData) => {
  return store.dispatch({
    action: 'table.folders/CREATE_FOLDER',
    method: 'POST',
    endpoint: '/stages/' + stage_id + '/folders',
    data: formData,
  });
};

export const updateFolder = (stage_id, folder_id, formData) => {
  return store.dispatch({
    action: 'table.folders/UPDATE_FOLDER',
    method: 'PUT',
    endpoint: '/stages/' + stage_id + '/folders/' + folder_id,
    data: formData,
  });
};

export const attachModelsToFolders = (stage_id, formData) => {
  return store.dispatch({
    action: 'table.folders/ATTACH_MODELS',
    method: 'POST',
    endpoint: '/stages/' + stage_id + '/folders/attach_models',
    data: formData,
  });
};

export const deleteFolder = (stage_id, folder_id) => {
  return store.dispatch({
    action: 'table.folders/DELETE_FOLDER',
    method: 'DELETE',
    endpoint: '/stages/' + stage_id + '/folders/' + folder_id,
  });
};
